import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import { Modal } from 'react-bootstrap';


// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class PaymentRequestTrainingDistanceIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      modal: false,
      modal_legs: false,
      reprove_id: null,
      justification: null,
      payment_legs: [],
      data: []
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.approve = this.approve.bind(this);
    this.reprove = this.reprove.bind(this);
    this.openModal = this.openModal.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }



  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/completo', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  openModal(payment_id) {
    var self = this;
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/pagamento/deslocamento/solicitacao/trechos/' + payment_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({payment_legs: responseJson.data, modal_legs: true});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }


  ActionsButtons (cell, row) {   
    var botao = (
      <div className="btn-group">
        {row.request == 1 && <button className="btn btn-sm btn-info" value={cell} onClick={() => this.openModal(cell)}>
          <i className="fa fa-fw fa-eye"></i>
        </button>}
      </div>
    );
    if(row.request_status === 'Aberta') {
      botao = (
        <div className="btn-group">
          <button className="btn btn-sm btn-success" value={cell} onClick={() => this.approve(cell)}>
            <i className="fa fa-fw fa-check"></i>
          </button>
          <button className="btn btn-sm btn-danger" value={cell} onClick={() => {this.setState({modal: true, justification: null, reprove_id: cell})}}>
            <i className="fa fa-fw fa-close"></i>
          </button>
          {row.request == 1 && <button className="btn btn-sm btn-info" value={cell} onClick={() => this.openModal(cell)}>
            <i className="fa fa-fw fa-eye"></i>
          </button>}
        </div>
      );
    }

    return botao;
  }

  approve (id) {
    var confirm = window.confirm('Tem certeza que gostaria de aprovar essa solicitação?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: id,
      };
  
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/aprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            fetch(config.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/completo', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                self.setState({data: responseJson.data});
              }
              self.handleAlert('Status de pagamento atualizado com sucesso', 'success', 'open');
            })
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }


  reprove (event) {
    event.preventDefault();
    var confirm = window.confirm('Tem certeza que gostaria de reprovar essa solicitação?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      var datasave = {
        id: this.state.reprove_id,
        request_justification: this.state.justification,
      };
  
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/reprovar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            fetch(config.get('api') + '/pagamento/treinamento/deslocamento/solicitacao/completo', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
              self.refs.request_api.validate(responseJson, 'url');
              if (responseJson.status === 'success') {
                self.setState({data: responseJson.data});
                self.setState({ modal: false, justification: null, reprove_id: null });
              }
              self.handleAlert('Status de pagamento atualizado com sucesso', 'success', 'open');
            })
          }
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-fluid">
    <div className="conteudo">
      <h3 className="page-title pull-left">Solicitações de Pagamento - Deslocamento - Treinamento</h3>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há solicitação de pagamento cadastrada'}} search={true} multiColumnSearch={true}  searchPlaceholder='Procurar'>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>ID</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
        <TableHeaderColumn dataField="request_status" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Status</TableHeaderColumn>
        <TableHeaderColumn dataField="payment_batch" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Lote</TableHeaderColumn>
        <TableHeaderColumn dataField="company" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Empresa</TableHeaderColumn>
        <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Treinamento</TableHeaderColumn>
        <TableHeaderColumn dataField="training_revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Revisão</TableHeaderColumn>
        <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Início</TableHeaderColumn>
        <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Fim</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_paid" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Quantidade</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_value" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Valor</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_total_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Valor Total</TableHeaderColumn>
        <TableHeaderColumn dataField="daily_currency" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Moeda</TableHeaderColumn>
        <TableHeaderColumn dataField="observation" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Observação</TableHeaderColumn>
        
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='150'>Ações</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
  <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'medium'}>
    <Modal.Header>
      <h4 className="pull-left">Reprovação de Pagamento</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, justification: null, reprove_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <form onSubmit={this.reprove}>
        <div className="row">
          <div className="col-md-12">
            <div className="form-group">
              <label>Justificativa:</label>
              <input type="text" name="justification" className="form-control" placeholder="" value={this.state.justification} onChange={this.handleChange.bind(this, 'justification')} required />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Reprovar pagamento</button>
          </div>
        </div>
      </form>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal: false, justification: null, reprove_id: null })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  <Modal show={this.state.modal_legs} bsSize={'large'} aria-labelledby="contained-modal-title-lg">
    <Modal.Header>
      <h4 className="pull-left">Bases</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_legs: false, payment_legs: [] })}>
      <i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="table-responsive">
        <table className="table table-bordered table-stripped table-hover">
          <thead>
            <tr>
              <th className="text-center">Origem</th>
              <th className="text-center">CEP Origem</th>
              <th className="text-center">Destino</th>
              <th className="text-center">CEP Destino</th>
            </tr>
          </thead>
          <tbody id="suppliers-certifications">
            {Object.keys(this.state.payment_legs).map(function(k) {
              return (
                <tr>
                  <td className="text-center">{self.state.payment_legs[k]['origin']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['zipcode_origin']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['destination']}</td>
                  <td className="text-center">{self.state.payment_legs[k]['zipcode_destination']}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={()=>this.setState({ modal_legs: false, payment_legs: [] })}>
      <i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>
</div>
    );
  }
}

export default PaymentRequestTrainingDistanceIndex;



// WEBPACK FOOTER //
// ./src/Components/PaymentRequests/PaymentRequestTrainingDistanceIndex.js